import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TARIFF_TYPES } from '@fttb/common/constants';
import { ymOrderTariffAddressView } from "../../analytics";
export var setOrderTariffAddressWithYM = function setOrderTariffAddressWithYM(tariffType, fieldName) {
  var addressFillFieldText = tariffType === TARIFF_TYPES.presetUp ? 'fmc_address_fill_field' : 'address_fill_field';
  ymOrderTariffAddressView(_defineProperty({}, addressFillFieldText, fieldName), tariffType);
};